import { useQuery } from '@tanstack/react-query';

import { MonitoringGateway } from 'src/features/monitoring/types';
import axios from 'src/lib/axios';
import { QueryConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';
import { ListResponseSmartParkAPI } from 'src/lib/queries';
import { STORAGE_PREFIX } from 'src/config';

const RESOURCE = `${STORAGE_PREFIX}/:parkingId/monitoring/gateway/`;

type QueryFnType = typeof queryFn;

type DTO = {
    parkingId: string;
}
const queryFn = ({ parkingId }: DTO): Promise<ListResponseSmartParkAPI<MonitoringGateway>> => {
    return axios.get(formatResourcePath(RESOURCE, { parkingId }));
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE],
        queryFn: async () => await queryFn(payload),
        ...config,
    });

export { useQueryHook as useListMonitoringGateways };
